import type { ReactNode } from 'react';
import { leaveRestaurant, staffSession } from '../lib/owner';
import { navigate } from '../lib/router';
import { Dot, Mango } from '../ui/icons';

const TABS = [['/floor', 'โต๊ะ · Floor'], ['/kitchen', 'ครัว · Kitchen'], ['/menu', 'เมนู · Menu'], ['/tables', 'QR · Tables'], ['/settings', 'ตั้งค่า · Settings']] as const;

/** Dark staff frame: restaurant name, live dot, tabs. */
export function Shell({ path, online, children, sub }: { path: string; online: boolean; children: ReactNode; sub?: string }) {
  const s = staffSession();
  return (
    <div className="staff">
      <header className="staff-top">
        <div className="who">
          <div className="logo"><Mango /></div>
          <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            <span className="display" style={{ fontSize: 20 }}>{s?.name ?? 'FirstMango'}</span>
            <span style={{ fontSize: 13, color: '#A9AFC6', display: 'flex', alignItems: 'center', gap: 6 }}>
              <Dot on={online} /> {online ? 'Live' : 'Reconnecting…'}{sub ? ` · ${sub}` : ''}
            </span>
          </div>
        </div>
        <nav className="tabs" aria-label="Views">
          {TABS.filter(([p]) => s?.role === 'owner' || p === '/floor' || p === '/kitchen').map(([p, label]) => (
            <button key={p} className="tab" aria-current={path === p ? 'page' : undefined} onClick={() => navigate(p)}>{label}</button>
          ))}
        </nav>
        <button className="btn-dark" onClick={leaveRestaurant}>เปลี่ยนร้าน · Switch</button>
      </header>
      <div className="staff-body">{children}</div>
    </div>
  );
}
